import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

const editModalFinancialBalanceSlice = createSlice({
  name: "editModalFinancialBalance",
  initialState,
  reducers: {
    openModal: (state, action) => {
      const itemId = action.payload;
      state[itemId] = true;
    },
    closeModal: (state, action) => {
      const itemId = action.payload;
      state[itemId] = false;
    },
  },
});

export const { openModal, closeModal } = editModalFinancialBalanceSlice.actions;

export default editModalFinancialBalanceSlice.reducer;
